
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

import type { SportEventV2Url } from '@/interfaces/sport-graphql';
import { MultiStepSportEvent } from '@/@types/graphql-types';

@Component({ name: 'MotorsportEventCard' })
export default class MotorsportEventCard extends Vue {
	@Prop({ required: true }) event: SportEventV2Url<MultiStepSportEvent>;
	@Prop({ default: false }) expandOffers: boolean;

	get fullPath() {
		return this.event.node.parent?.content?.fullPath;
	}

	get eventName() {
		return this.event.node.parent?.content.name;
	}

	get eventParentName() {
		const { name, number } = this.event.node.content?.competitionStage ?? {};
		if (name) {
			const nameCapitalised = `${name[0].toUpperCase()}${name.slice(1).toLowerCase()}`;
			return `${nameCapitalised} ${number ?? ''}`;
		}
	}

	get startDateTime() {
		const startAt = this.event.node.content?.startAt;
		return startAt == null ? null : new Date(this.event.node.content?.startAt);
	}

	get eventPath() {
		const path = { path: this.fullPath, query: {} };
		if (process.client) {
			// for SEO purposes to prevent google from indexing the URL with the stage parameter.
			const { name, number } = this.event.node.content?.competitionStage;
			path.query = { stage: `${name} ${number || ''}` };
		}
		return path;
	}
}
